import React from 'react';
// The site header shows this on every page, not only in the new flow's chunk.
import '../../../shared/theme/theme.scss';
import { Sheet } from '../../../shared/components/modals/Sheet';
import { HelpRequestForm } from './HelpRequestForm';

/**
 * The site header's "Let us help you" for brands and agencies: the brand app's
 * help form in the new flow's pop-up (it used to be the old web form).
 */
export function HelpRequestSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Sheet open={open} onClose={onClose} title="Let us help you" size="wide">
      {/* Mounted only while open: every opening starts a fresh form. */}
      {open && (
        <div className="brd-help brd-help--sheet">
          <HelpRequestForm variant="sheet" onDone={onClose} />
        </div>
      )}
    </Sheet>
  );
}

export default HelpRequestSheet;
